import React from 'react';
import { Button, Form, Input, Modal, notification, Select, Typography } from "antd";
import ApiService from "../../../services/ApiService";
import { EsriProvider } from 'leaflet-geosearch';
import ContactIcon from "../../../components/util-components/ContactIcon";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const provider = new EsriProvider();
const { Search } = Input;
const { Text, Title } = Typography;
const { Option } = Select;

export default class ModalAddFamilyLink extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        id: null,
        edit: false,
        parent: null,
        parentName: null,
        childId: null,
        defaultData: {},
        categories: [],
        selectedCategories: [],
        adresseOptions: [],
        contacts: []
    };

    state = this.initialState

    async show(parent, parentName) {
        await this.init()
        await this.initContact()
        this.setState({ visible: true, parent: parent, parentName: parentName })
    }

    async initContact() {
        var res = await ApiService.get("/contact/form")
        this.setState({ contacts: res.data })
    }

    onSearch = (text) => {
        this.setState({ text });
    }

    close() {
        this.setState(this.initialState)
    }

    componentDidMount() {
        this.init()
    }

    async init() {
        var res = await ApiService.get("/contact/categories")
        if (res.success) {
            this.setState({ categories: res.items })
        }
    }

    async onSelect() {
        if (!this.state.childId) {
            return false
        }

        var res = await ApiService.post("/contact/familylink/add/" + this.state.parent, { childId: this.state.childId })

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.id)
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }
    }

    async onSubmit(data) {
        if (this.state.edit && !this.state.id) {
            notification.error({
                message: t`Erreur lors de la modification`
            })
            this.close()
            return false
        }

        if (this.state.edit) {
            data.id = this.state.id
        }

        var res = await ApiService.post("/contact/familylink/add/" + this.state.parent, data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }
    }

    render() {
        return (
            <Modal
                width="100%"
                title={this.state.edit ? t`Éditer un lien familial` : t`Ajouter un lien familial`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Form
                    ref={(ref) => this.form = ref}
                    initialValues={this.state.defaultData}
                    onFinish={(data) => this.onSubmit(data)}
                >
                    <Title level={3} style={{ marginBottom: 20 }}>
                        {this.state.parentName} <Trans>est :</Trans>
                    </Title>

                    <Form.Item
                        label={<Trans>Type</Trans>}
                        name="type"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Select placeholder={t`Type de relation`}>
                            <Option value={"PERE"}><Trans>Père / Mère</Trans></Option>
                            <Option value={"MARI"}><Trans>Conjoint / Conjointe</Trans></Option>
                            <Option value={"ENFANT"}><Trans>Enfant</Trans></Option>
                            <Option value={"FRERE"}><Trans>Frère / Sœur</Trans></Option>
                            <Option value={"EX"}><Trans>Ex-conjoint / Ex-conjointe</Trans></Option>
                            <Option value={"BF"}><Trans>Beau-frère / Belle-sœur</Trans></Option>
                            <Option value={"COUSIN"}><Trans>Cousin / Cousine</Trans></Option>
                            <Option value={"AMI"}><Trans>Ami / Amie</Trans></Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={<Trans>Contact</Trans>}
                        name="childId"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Select
                            showSearch
                            filterOption={(input, option) => {
                                var text = option.props.children
                                if (Array.isArray(text)) {
                                    text = text.join("")
                                }
                                return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            placeholder={t`Choisir un contact`}
                            onSelect={(value) => {
                                this.setState({ childId: value })
                            }}
                        >
                            {this.state.contacts.map((item, index) => {
                                var email = item.email ? `(${item.email})` : ""
                                var tel = item.tel ? `(${item.tel})` : ""
                                return (
                                    <Option key={index} value={item.id}>
                                        <ContactIcon contact={item} /> {item.nom} {item.prenom} {tel} {email}
                                    </Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
